import "./industry.css"
import { Helmet } from "react-helmet-async"

export default function Industry({ industryInfo }) {
 return (
  <>
   <Helmet>
    <link rel="preload" as="image" href={industryInfo.img} />
   </Helmet>
   <div className="industry-container d-flex w-100 py-lg-4">
    <div className="industry-image-container">
     <img
      src={industryInfo.img}
      decoding="async"
      fetchpriority="high"
      className="industry-main-image" />
    </div>

    <aside className="rounded-border bg-secondary" data-aos="fade-up" data-aos-duration="200" data-aos-offset="50">
     <h2 className="h4">
      {industryInfo.title}
     </h2>
     <div className="pb-3 fs-sm-sm fs-lg-md">
      {industryInfo.description}
     </div>
    </aside>
   </div></>
 )
}